/**
 * @export
 * @class SelectReviewOptionFilterLayer
 * 옴션별 리뷰 보기 옵션 선택 레이어
 */
export default class SelectReviewOptionFilterLayer {
  constructor(aSelectedOption) {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_selectReviewOptionFilterLayer';

    this.aSelectedOption = aSelectedOption;

    // 레이어 중복 생성 방지
    if ($(`#${this.sWrapper}`).length < 1) {
      this.render();
    }
  }

  getOptionItemHtml = (htItem, nIdx) =>
    `<li class="option_review_item" data-index="${nIdx}" data-optionno="${htItem.dealNo}">
            <button type="button" class="option_review_button option_item">${htItem.title}</button>
        </li>`;

  /**
   * 옵션별 리뷰 보기를 위한 리뷰를 가진 옵션을 선택하는 셀렉터를 초기화
   */
  getOptionSelectorHtml() {
    const {
      reviewOptionTree: {
        data: { optionTreeTitles },
      },
    } = TMON.oApp.htStorage;

    // 단계별 구매하기 옵션 제목
    const aOptionTitles = optionTreeTitles;
    // 반환할 html 문자열
    let sHtml = '';

    if (!aOptionTitles || aOptionTitles.length < 1) {
      return '';
    }

    // 단계별 제목 및 리스트 render
    aOptionTitles.map((sTitle, nNum) => {
      // 옵션 변경 가능 여부
      let bChangeable = false;

      if (this.aSelectedOption.length > 1 && this.aSelectedOption === nNum) {
        bChangeable = true;
      } else if (nNum === 0) {
        bChangeable = true;
      }

      sHtml += `<!-- [D] 옵션 클릭시 on 클래스 추가 -->
                <div class="option_review_box" data-name="reviewDepSelWrap${nNum}">
                    <!-- 리뷰옵션 버튼 -->
                    <button type="button" class="option_review_button option_default" data-index="${nNum}"${
        nNum !== 0 ? 'disabled' : ''
      }>
                        <i>${sTitle}</i><span class="ico_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7"><path fill="#B7BFC8" fill-rule="evenodd" d="M5 7L0 0h10z"></path></svg></span>
                    </button>
                    <!-- 리뷰옵션 리스트 -->
                    <ul data-depth="${nNum}" class="option_review_list">${
        bChangeable
          ? TMON.oApp.oUtil
              .getReviewOptionTreeChildNodesByDepth(
                nNum,
                this.aSelectedOption.length > 1
                  ? this.aSelectedOption.aIndexList
                  : [0]
              )
              .map((htItem, nIdx) => this.getOptionItemHtml(htItem, nIdx))
              .join('')
          : ''
      }</ul>
                </div>`;

      return null;
    });

    return sHtml;
  }

  render = () => {
    const sHtml = `<section id="${
      this.sWrapper
    }" class="popup popup_option_review" style="display: flex;">
              <header class="popup_header">
                  <h3 class="popup_header_title">옵션별 리뷰보기</h3>
                  <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                          <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                      </svg>
                  </button>
              </header>
              <div class="option_review_wrap">
                  <div class="option_review_inner">
                      <div class="option_review_box_wrap">
                          ${this.getOptionSelectorHtml()}
                      </div>
                  </div>
                  <div class="option_review_button_area">
                      <!-- 취소 버튼 -->
                      <button type="button" class="option_review_button option_cancel" data-role="close">취소</button>
                      <!-- 확인 버튼  -->
                      <!-- [D] 활성화시 on 클래스 추가 -->
                      <button type="button" class="option_review_button option_confirm" data-role="close">확인</button>
                  </div>
              </div>
            </section>`;

    this.welContainer.append(sHtml);
  };

  open = () => {
    TMON.oApp.oUtil.handleOpenLayer({ welTargetLayer: $(`#${this.sWrapper}`) });
  };
}
